module.exports = __webpack_public_path__ + "img/2.213b7e52.png";